import { NavLink } from 'react-router-dom';

const CallToActionSection = () => {
  return (
    <section className="section-padding">
      <div className="container-custom">
        <div className="glass rounded-xl p-8 md:p-12 text-center relative overflow-hidden bg-adv-olive/10">
          <div className="absolute inset-0 bg-texture opacity-10 mix-blend-overlay"></div>
          
          <h2 className="heading-lg mb-4 relative z-10">Ready to Join the Adventure?</h2>
          <p className="text-adv-darkGray max-w-2xl mx-auto mb-8 relative z-10">
            Whether you're a seasoned rider or new to the ADV world, there's a place for you in our community.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 relative z-10">
            <NavLink to="/explore-rides" className="btn-primary">
              Find a Ride
            </NavLink>
            <NavLink to="/rallies" className="btn-primary">
              Join a Rally
            </NavLink>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToActionSection;
